var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery6Broken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.7 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fc0;\n      }\n\n      .cls-2 {\n        fill: #245f9b;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #f2f2f2;\n      }\n\n      .cls-5 {\n        fill: #f09202;\n      }\n\n      .cls-6 {\n        fill: #c48d2e;\n      }\n\n      .cls-7, .cls-8 {\n        fill: #d5dbe9;\n      }\n\n      .cls-9 {\n        display: none;\n      }\n\n      .cls-10 {\n        fill: #f0c01a;\n        isolation: isolate;\n        opacity: .6;\n      }\n\n      .cls-8 {\n        fill-rule: evenodd;\n      }\n\n      .cls-11 {\n        fill: #626067;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.6,68.3c-8-9.5-2.3-27.4,12.7-39.9,15-12.6,33.6-15.1,41.5-5.6l51.4,61.3c8,9.5,2.3,27.4-12.7,39.9-15,12.6-33.6,15.1-41.5,5.6l-51.4-61.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.7,67.7c-8.4-10.1-2.5-28.9,13.3-42.2,15.8-13.2,35.4-15.8,43.8-5.8l48.5,57.8c8.4,10.1,2.5,28.9-13.3,42.2-15.8,13.2-35.4,15.8-43.8,5.8l-48.5-57.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.3,95.9c-11.1-13.2-4-30.7,11.7-43.9,15.7-13.2,34.2-17.1,45.3-3.9l10.6,12.6,10.6,12.6c14.5,11.5,7.3,34.6-8.5,47.8-15.7,13.2-38.1,16.1-48.5,0l-21.2-25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M94.7,44.8c7.8,9.3,1.3,27.5-14.4,40.8-15.8,13.2-34.9,16.4-42.7,7.1-7.8-9.3-1.3-27.5,14.4-40.8,15.8-13.2,34.9-16.4,42.7-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.6,67.5l-7.1,6c-1.9,1.6-4.7.9-5.7-1.3l-6-13.6c-1.1-2.4-4.6-1.5-4.5,1.1l2.3,38.4c.2,3,3.7,4.6,6.1,2.6l7.1-6c1.9-1.6,4.7-.9,5.7,1.3l6,13.6c1.1,2.4,4.6,1.5,4.5-1.1l-2.3-38.4c-.2-3-3.7-4.6-6.1-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.6,67.5l-5.6,4.7c2,9.3-1,19.3-8.8,25.8-1.5,1.2-3.1,2.3-4.7,3.2,1.3.7,2.9.6,4.1-.4l7.1-6c1.9-1.6,4.7-.9,5.7,1.3l6,13.6c1.1,2.4,4.6,1.5,4.5-1.1l-2.3-38.4c-.2-3-3.7-4.6-6.1-2.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 41,
    cy: 38.7,
    rx: 33.5,
    ry: 17.2,
    transform: "translate(-15.3 35.4) rotate(-40)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 34.7,
    cy: 31.2,
    rx: 18.6,
    ry: 9.3,
    transform: "translate(-12 29.6) rotate(-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.7,96.5c7.1,12.2-2.4,31-21.3,41.8-18.8,10.9-39.8,9.8-46.9-2.5l-8.5-14.7c-7.1-12.2,13.1-12.6,31.9-23.4,18.8-10.9,29.2-28.1,36.2-15.9l8.6,14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M80.5,75c-8.2,8.4-24.6,17.3-22,25,2.1,6.1,8.2,15.1,10.9,18.9l63.1-36.4c1.5-1,7-.3-2.1-16-3.4-6-8.1-5.8-13.1-2.9-9,3.9-12.5-8.4-25.1-2.1-15.6,7.7-3.4,5-11.7,13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.8,130c7.5,13,29.7,14.2,49.4,2.8,19.8-11.4,29.8-31.2,22.3-44.2l-12-20.9c-2,.7-4.5,2.3-6.6,5-2.3,2.9-5.3,2-9.6.7-4.3-1.2-9.5-2.8-16.5-1.6-7.6,1.3-9.3,8-11.2,15-1.7,6-3.3,12.5-8.9,16.2-7.4,5.1-17.2,1.2-24-3l17.2,29.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86,95.8l30.7,14.4c2.7,1.2,4.9-2.3,2.8-4.3l-12.1-11.8c-2-2-1.7-5.2.7-6.5l8.9-5.2c2.9-1.7,2.6-6.1-.5-7.5-6.4-4.6-24.1-6.6-27.1,7.3-3.4,7.5-3.4,13.6-3.4,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.8,18.9c13.8,3.6,20.5,23.1,15,43.6-5.4,20.3-21.1,33.9-34.8,30.2l-6.2-1.7c-13.8-3.6-20.5-23.1-15-43.6C15.2,27.1,30.9,13.5,44.6,17.3c0,0,6.2,1.7,6.2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.7,92.3l46.2,12.3c5.1-2,10.1-5.7,7.6-12-2.6-6.7-1.2-8.9,1.1-12.7,1.6-2.4,3.4-5.3,5-10.5,2.3-7.3-2-11.9-5.8-16.3-3.3-3.6-6.3-7.1-4.9-11.4,1.6-4.7,3.9-6,5.8-7,1.9-1,3.1-1.7,2.3-5.3-.5-2.3-2.1-4.4-4-6.2l-32.6-8.7c-14.6-3.9-31,10.3-36.8,31.7C0,67.8,7.1,88.3,21.7,92.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74,55.2c-5.2,1.7-11.2,3.6-17.9,6.1-2.8,1-1.9,4.9,1.1,4.9h17c2.8,0,4.9,2.5,4.2,5l-2.6,9.6c-2.1,7.9,12.5-16.1-1.8-25.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 24.8,
    cy: 51.4,
    rx: 36.2,
    ry: 19.8,
    transform: "translate(-31.2 62) rotate(-75)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 14,
    cy: 48.6,
    rx: 20.1,
    ry: 10.7,
    transform: "translate(-36.6 49.6) rotate(-75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery6Broken);
export default __webpack_public_path__ + "static/media/battery-6-broken.11971410c37bd8ff2250837a187072f5.svg";
export { ForwardRef as ReactComponent };